import { translate } from '@jsverse/transloco';
import { ChecklistTypeIdEnum } from '../../_shared/models/checklist-type.model';
import { TableColumn } from '../models/compliance-item.model';
import { RequirementLayout } from '../models/requirement-layout.model';

/**
 * Builds the compliance asset list columns for the selected requirement.
 *
 * Inspection requirements show Asset, Compliance Standard, Last Inspection Date and Status.
 * Document requirements show the linked document with its dates, and gain the Action column
 * only when a document type is linked to the requirement.
 */
export function buildComplianceAssetListColumns(layout: RequirementLayout): TableColumn[] {
  const assetColumn: TableColumn = {
    header: translate('compliance.overview.assetList.columns.asset'),
    value: 'assetName',
    width: 'col-2',
    type: 'text',
    truncate: true,
    title: true,
    bold: true
  };
  const statusColumn: TableColumn = { header: translate('compliance.overview.assetList.columns.status'), value: 'status', width: 'col', type: 'status' };

  if (layout.checklistType === ChecklistTypeIdEnum.Inspection) {
    return [
      { ...assetColumn, width: 'col' },
      { header: translate('compliance.overview.assetList.columns.complianceStandard'), value: 'complianceType', width: 'col', type: 'text' },
      { header: translate('compliance.overview.assetList.columns.lastInspectionDate'), value: 'lastInspectionDate', width: 'col', type: 'text' },
      { ...statusColumn, width: 'col-2' }
    ];
  }

  const columns: TableColumn[] = [
    assetColumn,
    { header: translate('compliance.overview.assetList.columns.complianceType'), value: 'complianceType', width: 'col', type: 'text' },
    {
      header: translate('compliance.overview.assetList.columns.document'),
      value: 'document',
      width: 'col',
      type: 'link',
      linkValue: 'linkedDocumentId',
      subLabelValue: 'documentExpiry',
      mutedValue: translate('compliance.overview.assetList.noDocument')
    },
    { header: translate('compliance.overview.assetList.columns.dateIssued'), value: 'dateIssued', width: 'col', type: 'text' },
    { header: translate('compliance.overview.assetList.columns.daysOverdue'), value: 'overdueDays', width: 'col', type: 'text' },
    statusColumn
  ];

  if (layout.hasLinkedDocumentType) {
    columns.push({ header: translate('compliance.overview.assetList.columns.action'), value: 'action', width: 'col-1', type: 'action' });
  }

  return columns;
}